import React, {useRef } from 'react';
import './portfolio.styles.scss';
import { AnchorLink} from 'gatsby-plugin-anchor-links';


const Portfolio = () => {
    const sections = [
        {section: 'EDM & DANCE', id: 'edm'},
        {section: 'POP', id: 'pop'},
        {section: 'LATIN', id: 'latin'},
        {section: 'KIDS SONGS', id: 'kids'},
        {section: 'JAZZ & OTHERS', id: 'others'},
        {section: 'JINGLES', id: 'jingles'}
    ];
    const box = useRef();
    // const [isHovered, setIsHovered] = useState(false)

    // useEffect(() => {
    //     box.current.addEventListener('mouseover', () => {
    //         setIsHovered(true)
    //     })

      
    // }, [])

  
 
    return (
        <div className='portfolio-container'>
            
            {
                sections.map((section) => {
                    return (
                        <AnchorLink to={`/work#${section.id}`} key={section.section}  >
                        <div className='box' ref={box}>
                            <div className="inner-box">
                            
                                
                                    <h3>{section.section}</h3>
                                
                          
                            </div>
                            
                        </div>
                        </AnchorLink>
                    )
                })
            }
            
        </div>
    )
}

export default Portfolio;